import React, { useState } from 'react';
import NavigationBar from '../../components/navbar/component'
import Head from '../../components/head/component'
import Image from '../../image/ContactCover.png'
import {
    Footer
} from '../../components/footer/components'
import { 
    Wrapper,
    Form,
    FormTitle,
    FormCaption,
    FormArea,
    ContactYouAbout,
    ContactYouInput,
    NameContainer,
    FirstNameContainer,
    LastNameContainer,
    InputField,
    EmailContainer,
    EmailFieldContainer,
    PhoneContainer,
    CompanyContainer,
    EmailBoxContainer,
    RequiredFieldsText,
    Line,
    SubmitButton,
    LastRow,
    LeftBox
 } from './style'
import { postNewSubscriber } from '../../api';

export const Contact = () => {
    
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [state, setState] = useState(0);
    return (
        <>
            <NavigationBar />
            <Head 
                imagePath={Image}
                caption='YOUR LEGAL SOLUTIONS START ON A CLICK AWAY'
            />
            <Wrapper>
                <Form>
                    <FormTitle>
                        STAY CONNECTED
                    </FormTitle>
                    <FormCaption>
                        Use this form to contact us for law case, 
                        career information, corporate information, 
                        or general questions. 
                    </FormCaption>
                    <FormArea>
                        <ContactYouAbout>
                            I AM CONTACT YOU ABOUT
                            <ContactYouInput 
                                styles={{
                                    control: (baseStyles) => ({
                                    ...baseStyles,
                                        height: '62px', // Fixed height
                                        minHeight: '62px', // Ensures minimum height
                                    })
                                }}
                                placeholder="Please Select"
                            />
                        </ContactYouAbout>

                        <NameContainer>
                            <FirstNameContainer>
                                <div>FIRST NAME</div>
                                <InputField
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </FirstNameContainer>
                            <LastNameContainer>
                                <div>LAST NAME</div>
                                <InputField 
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </LastNameContainer>
                        </NameContainer>
                        <EmailContainer>
                            <EmailFieldContainer>
                                <div>Email Address *</div>
                                <InputField 
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </EmailFieldContainer>
                            <PhoneContainer>
                                <div>Phone</div>
                                <InputField />
                            </PhoneContainer>
                        </EmailContainer>
                        <CompanyContainer>
                            <EmailBoxContainer>
                                <div>Company</div>
                                <InputField />
                            </EmailBoxContainer>
                        </CompanyContainer>

                        
                        <LastRow>
                            <LeftBox>
                                <RequiredFieldsText>
                                    * Required Fields
                                </RequiredFieldsText>
                                <Line />
                            </LeftBox>
                            <div>
                                <SubmitButton
                                    onClick={
                                        async() => {
                                            if (email === '') {
                                                setState(3);
                                                return;
                                            }

                                            const result = await postNewSubscriber(email, `${firstName} ${lastName}`);
                                            if(result === 200) {
                                                setState(1);
                                            } else {
                                                setState(2);
                                            }
                                        }
                                    }
                                >
                                    SUBMIT
                                </SubmitButton>
                                <div>
                                    {state === 1 && <div>Successfully Subscribed!</div>}
                                    {state === 2 && <div style={{ color: 'red' }}>The email has already been added to the list!</div>}
                                    {state === 3 && <div style={{ color: 'red' }}>Please fill in all the required fields!</div>}
                                </div>
                            </div>
                        </LastRow>
                    </FormArea>
                </Form>
            </Wrapper>
            <Footer />
        </>
    )
}